import { createTheme } from '@mui/material/styles';
import { portalBrand } from '../configs/brand';

// assets
import colors from 'assets/scss/_themes-vars.module.scss';

// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';
import applyAccentOverrides from './accentOverrides';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

export const theme = (customization) => {
    const color = {
        ...colors,
        primaryLight: portalBrand.light,
        primaryMain: portalBrand.main,
        primaryDark: portalBrand.dark,
        primary200: portalBrand.border,
        primary800: portalBrand.dark,
        secondaryLight: portalBrand.light,
        secondaryMain: portalBrand.main,
        secondaryDark: portalBrand.dark,
        secondary200: portalBrand.muted,
        secondary800: portalBrand.dark
    };

    const themeOption = {
        colors: color,
        heading: color.grey900,
        paper: color.paper,
        backgroundDefault: color.paper,
        background: color.primaryLight,
        darkTextPrimary: color.grey700,
        darkTextSecondary: color.grey500,
        textDark: color.grey900,
        textBlue: color.primaryDark,
        menuSelected: portalBrand.accent,
        menuSelectedBack: portalBrand.accentLight,
        divider: color.grey200,
        customization
    };

    const themeOptions = {
        direction: 'ltr',
        palette: { ...themePalette(themeOption), accent: { main: portalBrand.accent } },
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        typography: themeTypography(themeOption)
    };

    const themes = createTheme(themeOptions);
    themes.components = applyAccentOverrides(componentStyleOverrides(themeOption), portalBrand.accent);

    return themes;
};

export default theme;
